import React, { useEffect, useState } from 'react';

import {
    Box, Checkbox, TextField, Typography

} from '@mui/material';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../utility/helper';
import validator from 'validator';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';

const EmailConfiguration = (props) => {

    const [eventInfo, setEventInfo] = useState(null);
    const [userInfo, setUserInfo] = useState(null);

    const [emailInfo, setEmailInfo] = useState({
        id: 0,
        isEnabled: { value: false, error: false, errorMsg: '' },
        toEmail: { value: '', error: false, errorMsg: '' },
        ccEmail: { value: '', error: false, errorMsg: '' },
        bccEmail: { value: '', error: false, errorMsg: '' }
    });
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [isLoading, setIsLoading] = useState(false);
    const [disableButton, setDisableButton] = useState(false);


    useEffect(() => {
        const userEventInfo = Helper.getStorage('eventInfo');
        const guserInfo = Helper.getStorage('userInfo');
        setEventInfo(userEventInfo);
        setUserInfo(guserInfo);

        getEmailConfig(userEventInfo.eventID, props.data && props.data.length > 0 ? props.data[0].type : '');
    }, []);

    const handleChange = (fieldName, val) => {
        setEmailInfo({
            ...emailInfo,
            [fieldName]: { value: val, error: false }
        });
    }
    const validateEmail = (value) => {
        value = value.trim();
        if (validator.isEmail(value)) {
            return true;
        } else return false;
    };

    const isValidEmailField = (fieldName) => {
        let flag = true;
        const email = emailInfo && emailInfo[fieldName] ? emailInfo[fieldName].value.trim() : '';
        let selectedEmails = [];
        if (email) {
            selectedEmails = email.split(',');
            selectedEmails.forEach((item) => {
                flag = item != '' ? validateEmail(item) : true;
                if (!flag)
                    return;
            });
        };
        return flag;
    };

    const checkValidEmail = (fieldName) => {
        let isValid = isValidEmailField(fieldName);
        setEmailInfo({
            ...emailInfo,
            [fieldName]: { value: emailInfo[fieldName].value, error: !isValid, errorMsg: 'Please enter valid Email' }
        });
    }

    const getEmailConfig = (eventID, type) => {
        ApiHelper.get(
            APIURLConstants.GET_ACTIVITY_TRACKER_EMAIL_CONFIG(eventID, type)
        ).then((res) => {
            if (res.data) {
                setEmailInfo({
                    id: res.data.ActivityTrackerEmailConfigID,
                    isEnabled: { value: res.data.isEnabled, error: false, errorMsg: '' },
                    toEmail: { value: res.data.toEmail, error: false, errorMsg: '' },
                    ccEmail: { value: res.data.ccEmail, error: false, errorMsg: '' },
                    bccEmail: { value: res.data.bccEmail, error: false, errorMsg: '' }
                })
            }
        }).catch((error) => {
            if (error.response && error.response.status === 401) {
                alert(error);
            }
        });
    }

    const handleSave = () => {
        let isValid = isValidData();
        if (isValid) {
            setIsLoading(true);
            //setDisableButton(true);
            let requestObj = {
                eventID: eventInfo.eventID,
                isEnabled: emailInfo.isEnabled.value ? emailInfo.isEnabled.value : false,
                toEmail: emailInfo.toEmail.value,
                ccEmail: emailInfo.ccEmail.value,
                bccEmail: emailInfo.bccEmail.value,
                EmailType: props.data && props.data.length > 0 ? props.data[0].type : '',
                createdBy: userInfo.userID,
            };

            ApiHelper.post(APIURLConstants.SAVE_ACTIVITY_TRACKER_EMAIL_INFO, requestObj)
                .then((res) => {
                    setIsLoading(false);
                    if (res.data > 0) {
                        let msg = 'Email Info updated successfully';
                        setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: msg,
                        });
                    }
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while Updating Module';
                    }
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                })
        }
    }

    const isValidData = () => {
        let isValid = true;
        let updatedData = { ...emailInfo };
        if (!emailInfo.toEmail.value) {
            updatedData.toEmail.error = true;
            updatedData.toEmail.errorMsg = 'Please Enter To Email';
            isValid = false;
        } else if (!isValidEmailField('toEmail')) {
            updatedData.toEmail.error = true;
            updatedData.toEmail.errorMsg = 'Please Enter valid Email';
            isValid = false;
        }
        else {
            updatedData.toEmail.error = false;
        }

        if (emailInfo.ccEmail.value && !isValidEmailField('ccEmail')) {
            updatedData.ccEmail.error = true;
            updatedData.ccEmail.errorMsg = 'Please Enter valid Email';
            isValid = false;
        } else {
            updatedData.ccEmail.error = false;
        }

        if (emailInfo.bccEmail.value && !isValidEmailField('bccEmail')) {
            updatedData.bccEmail.error = true;
            updatedData.bccEmail.errorMsg = 'Please Enter valid Email';
            isValid = false;
        } else {
            updatedData.bccEmail.error = false;
        }
        setEmailInfo(updatedData);

        return isValid;
    }

    return (
        <Box sx={{
            margin: 2
        }}>
            <Box
                sx={{
                    flex: 1,
                    flexDirection: 'row',
                    width: '100%'
                }}>

                <Checkbox
                    checked={emailInfo.isEnabled.value} onChange={(e) => handleChange('isEnabled', e.target.checked)}
                />
                Enable Email

            </Box>
            <Box sx={{
                flex: 1,
                flexDirection: 'column',
                width: '100%',
                // display:'flex'
            }}>
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: '.7rem',
                        color: 'red',
                        pl: 2.5,
                    }}
                    h5>
                    {' '}
                    Separate e-mails by comma(,)
                </Typography>
                <TextField
                    fullWidth
                    sx={{
                        marginRight: 2,
                        marginTop: 2,
                    }}
                    value={emailInfo.toEmail.value}
                    size="small"
                    id="outlined-required"
                    label="TO"
                    onChange={(e) => {
                        let str = e.target.value;
                        str = str.replace(/^\s+/g, '');
                        handleChange('toEmail', str);
                    }}
                    onBlur={() => checkValidEmail('toEmail')
                    }
                    error={emailInfo.toEmail && emailInfo.toEmail.error ? emailInfo.toEmail.error : false}
                    helperText={emailInfo.toEmail && emailInfo.toEmail.error ? emailInfo.toEmail.errorMsg : ''}
                />
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: '.7rem',
                        color: 'red',
                        pl: 2.5,
                        marginTop: 2,
                    }}
                    h5>
                    {' '}
                    Separate e-mails by comma(,)
                </Typography>
                <TextField
                    fullWidth
                    sx={{
                        marginRight: 2,
                        marginTop: 2,
                    }}
                    value={emailInfo.ccEmail.value}
                    size="small"
                    id="outlined-required"
                    label="CC"
                    onChange={(e) => {
                        let str = e.target.value;
                        str = str.replace(/^\s+/g, '');
                        handleChange('ccEmail', str);
                    }}
                    onBlur={() => checkValidEmail('ccEmail')
                    }
                    error={emailInfo.ccEmail && emailInfo.ccEmail.error ? emailInfo.ccEmail.error : false}
                    helperText={emailInfo.ccEmail && emailInfo.ccEmail.error ? emailInfo.ccEmail.errorMsg : ''}
                />
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: '.7rem',
                        color: 'red',
                        pl: 2.5,
                        marginTop: 2,
                    }}
                    h5>
                    {' '}
                    Separate e-mails by comma(,)
                </Typography>

                <TextField
                    fullWidth
                    sx={{
                        marginRight: 2,
                        marginTop: 2,
                    }}
                    value={emailInfo.bccEmail.value}
                    size="small"
                    id="outlined-required"
                    label="BCC"
                    onChange={(e) => {
                        let str = e.target.value;
                        str = str.replace(/^\s+/g, '');
                        handleChange('bccEmail', str);
                    }}
                    onBlur={() => checkValidEmail('bccEmail')
                    }
                    error={emailInfo.bccEmail && emailInfo.bccEmail.error ? emailInfo.bccEmail.error : false}
                    helperText={emailInfo.bccEmail && emailInfo.bccEmail.error ? emailInfo.bccEmail.errorMsg : ''}
                />
            </Box>
            <Box sx={{
                topMargin: 2
            }}>
                <ButtonContainer
                    handleClick={handleSave}
                    hideCancel
                    showLoading={isLoading}
                    disableButton={disableButton}
                    //handleCancel={props.handleCloseModule}
                    buttonText={'Save'}
                />
            </Box>
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>

    )
}

export default EmailConfiguration;